<h4 class="modal-header-label"> {{'UPDATE PASSWORD'}}</h4>

<div class="form-group mb-1">
    <label for="password" class="profile-labels">Current Password</label>
    <div class="input-group input-group-sm">
      <input [type]="passwordType" #password [(ngModel)]="user.password" [ngModelOptions]="{standalone: true}"
        class="form-control form-control-sm profile-input" />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer" (click)="togglePassword()">
          <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="passwordType=='password'"></i>
          <i class="fa fa-eye" aria-hidden="true" *ngIf="passwordType=='text'"></i>
        </span>
      </div>
    </div>

  </div>
  <div class="form-group">
    <label for="new_password" class="profile-labels">New Password</label>
    <div class="input-group input-group-sm">
      <input [type]="newPasswordType" #new_password [(ngModel)]="user.new_password" [ngModelOptions]="{standalone: true}"
        class="form-control form-control-sm profile-input" />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer" (click)="toggleNewPassword()">
          <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="newPasswordType=='password'"></i>
          <i class="fa fa-eye" aria-hidden="true" *ngIf="newPasswordType=='text'"></i>
        </span>
      </div>
    </div>
  </div>
<div class="float-right">
  <button type="button" [disabled]="false" class="sm-button"
    (click)="onSaveClick()">Save</button>
  <button type="button" *ngIf="true" class="sm-button ml-2" (click)="onCancelClick()">Cancel</button>
</div>